module.exports = __webpack_public_path__ + "img/1w_tassei.25da12f3.png";